import axios, { Axios, AxiosInstance } from "axios";
import config from "@/config";

const instance: AxiosInstance = axios.create({
  baseURL: config.briumApiBaseUrl,
  headers: {},
});

export default instance as Axios;
